export const IS_PROD_ENV = process.env.NEXT_PUBLIC_APP_ENV !== 'development'
